module.exports = __webpack_public_path__ + "img/192.be20e110.jpg";